import { MilestoneIcon } from 'lucide-react'

import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { cn } from '@/lib/utils'

import { VisaBulletinInfoCard } from '../../../../ui/cards/visa-bulletin-info-card/visa-bulletin-info-card'
import { VisaBulletinTrendCard } from '../../../../ui/cards/visa-bulletin-trend-card/visa-bulletin-trend-card'
import { NoDataCard } from '../no-data-card/no-data-card'
import { useVisaBulletin } from './use-visa-bulletin'

export const VisaBulletin = () => {
  const {
    noData,
    visaBulletinData,
    visaBulletinTrendData,
    priorityDate,
    showsVisaBulletinInfo,
    showsVisaBulletinTrend,
    navigateToCaseDetail,
  } = useVisaBulletin()

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<MilestoneIcon size={24} />} title="Visa Bulletin" />

      {noData && (
        <div className={cn('mt-5')}>
          <NoDataCard
            cardTitle="Please set visa bulletin alert to display visa bulletin information."
            cardDescription="This message won't be shown to clients"
            buttonLabel="Set visa bulletin alert"
            onClickButton={navigateToCaseDetail}
          />
        </div>
      )}

      {!noData && (
        <div
          className={cn('flex flex-col gap-y-5 lg:grid', 'mt-5', {
            'lg:grid-cols-[400px_auto] lg:gap-5': showsVisaBulletinInfo && showsVisaBulletinTrend,
          })}
        >
          {showsVisaBulletinInfo && (
            <div className={cn('lg:max-w-[400px]')}>
              <VisaBulletinInfoCard visaBulletinData={visaBulletinData} />
            </div>
          )}
          {showsVisaBulletinTrend && (
            <div
              className={cn(
                'min-w-0' // prevent grid content from overflowing grid item
              )}
            >
              <VisaBulletinTrendCard visaBulletinTrendData={visaBulletinTrendData} priorityDate={priorityDate} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
